/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Star(props) {
  return (
    <svg {...props} viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.72824 1.47638C7.22986 0.414353 8.76955 0.416497 9.27121 1.47638L9.31808 1.58576L9.32297 1.59748L10.6765 5.34748H14.0056C15.3063 5.34748 15.93 6.97174 14.9148 7.81623L12.5124 9.97736L12.5154 9.98615L13.3904 13.6971C13.8002 14.9867 12.3322 15.9899 11.2595 15.2723V15.2733L7.99973 13.2049L4.73996 15.2733L4.73898 15.2723C3.66782 15.988 2.20223 14.987 2.60715 13.701L3.4841 9.98615L3.48605 9.97736L1.08469 7.81623C0.0679598 6.97083 0.695946 5.34803 1.99289 5.34748H5.32297L6.67746 1.59748L6.68137 1.58673L6.72824 1.47638Z"
        fill="#E8A51F"
      />
    </svg>
  )
}

Star.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Star
